<div id="<%= dom_id entry %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Lead:</strong>
    <%= entry.lead_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Follow:</strong>
    <%= entry.follow_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Instructor:</strong>
    <%= entry.instructor_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Age:</strong>
    <%= entry.age_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Level:</strong>
    <%= entry.level_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Studio:</strong>
    <%= entry.studio_id %>
  </div>
</div>
